import React from "react";
import { MapPin } from "lucide-react";

const suburbs = [
    "Queanbeyan",
    "Canberra",
    "Tuggeranong",
    "Googong",
    "Jerrabomberra",
    "Karabar",
    "Crestwood",
    "Greenleigh",
    "Oaks Estate",
    "Fyshwick",
    "Narrabundah",
    "Kingston",
    "Griffith",
    "Red Hill",
    "Deakin",
    "Woden",
];

export default function ServiceArea() {
    return (
        <section
            id="area"
            data-testid="section-area"
            className="relative bg-[var(--paper)] py-28 md:py-36 border-t border-line"
        >
            <div className="maxw section-pad">
                <div className="grid md:grid-cols-12 gap-14">
                    <div className="md:col-span-5">
                        <div className="eyebrow mb-5">Service area</div>
                        <h2 className="font-display font-light text-4xl sm:text-5xl md:text-[54px] leading-[1.02] tracking-tight">
                            Covering Queanbeyan, Canberra,{" "}
                            <span className="italic text-[var(--terra)]">
                                Tuggeranong
                            </span>{" "}
                            &amp; surrounding areas.
                        </h2>
                        <p className="mt-6 text-[rgba(14,14,16,0.72)] text-base leading-relaxed max-w-md">
                            A tight local radius, no surprise travel fees. If
                            your suburb isn’t listed, send us a note — we’ll
                            usually have you covered or know a trusted crew that
                            does.
                        </p>

                        <div className="mt-8 flex flex-wrap gap-3">
                            <a href="#contact" className="btn-ink" data-testid="area-cta">
                                Check my suburb →
                            </a>
                            <a
                                href="tel:0435995971"
                                className="btn-ghost"
                                data-testid="area-cta-call"
                            >
                                Call 0435 995 971
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-7">
                        <div className="rounded-2xl border border-line bg-[rgba(233,226,211,0.5)] p-7 md:p-9">
                            <div className="flex items-center justify-between mb-6">
                                <div className="eyebrow">Currently servicing</div>
                                <div className="font-mono-x text-[11px] text-[rgba(14,14,16,0.48)]">
                                    {suburbs.length} suburbs · &amp; surrounding
                                </div>
                            </div>
                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-px bg-[var(--line)] border border-line rounded-xl overflow-hidden">
                                {suburbs.map((s) => (
                                    <div
                                        key={s}
                                        className="bg-[var(--paper)] px-4 py-3.5 flex items-center gap-2 hover:bg-[var(--paper-2)] transition-colors"
                                        data-testid={`area-${s.toLowerCase().replace(/\s/g, "-")}`}
                                    >
                                        <MapPin
                                            size={13}
                                            className="text-[var(--terra)] shrink-0"
                                        />
                                        <span className="font-display text-[15px] tracking-tight">
                                            {s}
                                        </span>
                                    </div>
                                ))}
                            </div>
                            <p className="mt-6 text-[13px] text-[rgba(14,14,16,0.6)]">
                                And surrounding areas. Not sure if you’re in?
                                Just ask — we’ll let you know straight up.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
